(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope','Principal','LoginService','$state','ToastrService',
                            'ContractGridDTO','ShipmentGridDTO','InvoiceGridDTO'];

    function HomeController($scope, Principal, LoginService, $state, ToastrService,
                            ContractGridDTO, ShipmentGridDTO, InvoiceGridDTO) {
        var vm = this;

        vm.account = null;
        vm.purchaseContracts = [];
        vm.saleContracts = [];
        vm.shipments = [];
        vm.purchaseInvoices = [];
        vm.saleInvoices = [];
        vm.japanInvoices = [];
        vm.paginationItemsBeforeEllipsis = 5;
        vm.purchaseContractPagination = {
            total: 0,
            curPage: 1
        };
        vm.saleContractPagination = {
            total: 0,
            curPage: 1
        };
        vm.shipmentPagination = {
            total: 0,
            curPage: 1
        };
        vm.purchaseInvoicePagination = {
            total: 0,
            curPage: 1
        };
        vm.saleInvoicePagination = {
            total: 0,
            curPage: 1
        };
        vm.japanInvoicePagination = {
            total: 0,
            curPage: 1
        };
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function () {
            getAccount();
        });

        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
                getPurchaseContracts(1);
                getSaleContracts(1);
                getShipments(1);
                if(!vm.account.authorities.includes('ROLE_AGENT')) {
                    getPurchaseInvoices(1);
                    getSaleInvoices(1);
                    getJapanInvoices(1);
                }
            });
        }

        if(vm.isAuthenticated()) {
            getAccount();
        }

        function register() {
            $state.go('register');
        }

        vm.refreshPurchaseContracts = getPurchaseContracts;
        vm.refreshSaleContracts = getSaleContracts;
        vm.refreshShipments = getShipments;
        vm.refreshPurchaseInvoices = getPurchaseInvoices;
        vm.refreshSaleInvoices = getSaleInvoices;
        vm.refreshJapanInvoices = getJapanInvoices;

        function getPurchaseContracts(page) {
            vm.filterModelPurchaseContract = {
                contractNum: '',
                contractType: 'PURCHASE',
                priceModel: '',
                seller: '',
                buyer: '',
                agent: '',
                loadingPort: '',
                destinationPort: '',
                incoTerms: '',
                paymentTerms: '',
                grade: '',
                contractDateFrom: null,
                contractDateTo: null,
                cropYear: '',
                growth: '',
                draft: true,
                issued: true,
                complete: true,
                cancelled: true,
                categoryTui: true,
                categoryJapan: true,
                subCategoryJapan: true,
                subCategoryOutside: true,
                subCategoryPurchase: true,
                subCategoryDirect: true
            };
            var predicate = 'modifiedOn';
            var order = 'desc';
            var sort = [predicate + ',' + order];
            var queryParams = {
                page: page - 1,
                size: 10,
                sort: sort
            };
            queryParams = Object.assign({}, queryParams, vm.filterModelPurchaseContract);
            ContractGridDTO.query(queryParams, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.purchaseContracts = [];
                vm.purchaseContractPagination.total = headers('X-Total-Count');
                vm.purchaseContractPagination.curPage = page;
                for(var i = 0; i < data.length; i++) {
                    vm.purchaseContracts.push(data[i]);
                }
            }

            function onError(error) {
                if(error.status !== 401) {
                    ToastrService.error("Failed to get Purchase Contracts", "Error!");
                }
            }
        }

        function getSaleContracts(page) {
            vm.filterModelSaleContract = {
                contractNum: '',
                contractType: 'SALE',
                priceModel: '',
                seller: '',
                buyer: '',
                agent: '',
                loadingPort: '',
                destinationPort: '',
                incoTerms: '',
                paymentTerms: '',
                grade: '',
                contractDateFrom: null,
                contractDateTo: null,
                cropYear: '',
                growth: '',
                draft: true,
                issued: true,
                complete: true,
                cancelled: true,
                categoryTui: true,
                categoryJapan: true,
                subCategoryJapan: true,
                subCategoryOutside: true,
                subCategoryPurchase: true,
                subCategoryDirect: true
            };
            var predicate = 'modifiedOn';
            var order = 'desc';
            var sort = [predicate + ',' + order];
            var queryParams = {
                page: page,
                size: 10,
                sort: sort
            };
            queryParams = Object.assign({}, queryParams, vm.filterModelSaleContract);
            ContractGridDTO.query(queryParams, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.saleContracts = [];
                vm.saleContractPagination.total = headers('X-Total-Count');
                vm.saleContractPagination.curPage = page;
                for(var i = 0; i < data.length; i++) {
                    vm.saleContracts.push(data[i]);
                }
            }

            function onError(error) {
                if(error.status !== 401) {
                    ToastrService.error("Failed to get Sale Contracts", "Error!");
                }
            }
        }

        function getShipments(page) {
            vm.filterModelShipment = {
                shipmentNum: '',
                siDateFrom: null,
                siDateTo: null,
                qtyBalesFrom: null,
                qtyBalesTo: null,
                lcNumber: '',
                lcBankRef: '',
                blNumber: '',
                boeRef: '',
                shipmentBookingNumber: '',
                purchaseCropYear: '',
                saleCropYear: '',
                purchaseContract: '',
                saleContract: '',
                purchaseInvoice: '',
                saleInvoice: '',
                purchaseContractGrowth: '',
                saleContractGrowth: '',
                buyer: '',
                seller: '',
                forReport: true,
                statusDraft: true,
                statusAllocated: true,
                statusScheduled: true,
                statusDraftReceived: true,
                statusShipped: true,
                statusInvoiced: true,
                statusCancelled: true,
                saleNContractAmountFrom: '',
                saleNContractAmountTo: ''
            };
            var predicate = 'modifiedOn';
            var order = 'desc';
            var sort = [predicate + ',' + order];
            var queryParams = {
                page: page,
                size: 10,
                sort: sort
            };
            queryParams = Object.assign({}, queryParams, vm.filterModelShipment);
            ShipmentGridDTO.query(queryParams, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.shipments = [];
                vm.shipmentPagination.total = headers('X-Total-Count');
                vm.shipmentPagination.curPage = page;
                for(var i = 0; i < data.length; i++) {
                    vm.shipments.push(data[i]);
                }
            }

            function onError(error) {
                if(error.status !== 401) {
                    ToastrService.error("Failed to get Shipments", "Error!");
                }
            }
        }

        function getPurchaseInvoices(page) {
            vm.filterModelPurchaseInvoice = {
                invoiceNum: '',
                invDateFrom: '',
                invDateTo: '',
                status: '',
                type: 'PURCHASE',
                qtyBalesFrom: '',
                qtyBalesTo: '',
                valueFrom: '',
                valueTo: '',
                shipmentNum: '',
                shipmentStatus: '',
                shipmentBL: '',
                shipmentLC: '',
                contractNum: '',
                contractStatus: '',
                contractType: ''
            };
            var predicate = 'modifiedOn';
            var order = 'desc';
            var sort = [predicate + ',' + order];
            var queryParams = {
                page: page,
                size: 10,
                sort: sort
            };
            queryParams = Object.assign({}, queryParams, vm.filterModelPurchaseInvoice);
            InvoiceGridDTO.query(queryParams, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.purchaseInvoices = [];
                vm.purchaseInvoicePagination.total = headers('X-Total-Count');
                vm.purchaseInvoicePagination.curPage = page;
                for(var i = 0; i < data.length; i++) {
                    vm.purchaseInvoices.push(data[i]);
                }
            }

            function onError(error) {
                if(error.status !== 401) {
                    ToastrService.error("Failed to get Purchase Invoices", "Error!");
                }
            }
        }

        function getSaleInvoices(page) {
            vm.filterModelSaleInvoice = {
                invoiceNum: '',
                invDateFrom: '',
                invDateTo: '',
                status: '',
                type: 'SALE-DASH',
                qtyBalesFrom: '',
                qtyBalesTo: '',
                valueFrom: '',
                valueTo: '',
                shipmentNum: '',
                shipmentStatus: '',
                shipmentBL: '',
                shipmentLC: '',
                contractNum: '',
                contractStatus: '',
                contractType: ''
            };
            var predicate = 'modifiedOn';
            var order = 'desc';
            var sort = [predicate + ',' + order];
            var queryParams = {
                page: page,
                size: 10,
                sort: sort
            };
            queryParams = Object.assign({}, queryParams, vm.filterModelSaleInvoice);
            InvoiceGridDTO.query(queryParams, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.saleInvoices = [];
                vm.saleInvoicePagination.total = headers('X-Total-Count');
                vm.saleInvoicePagination.curPage = page;
                for(var i = 0; i < data.length; i++) {
                    vm.saleInvoices.push(data[i]);
                }
            }

            function onError(error) {
                if(error.status !== 401) {
                    ToastrService.error("Failed to get Sale Invoices", "Error!");
                }
            }
        }

        function getJapanInvoices(page) {
            vm.filterModelJapanInvoice = {
                invoiceNum: '',
                invDateFrom: '',
                invDateTo: '',
                status: '',
                type: 'JAPAN',
                qtyBalesFrom: '',
                qtyBalesTo: '',
                valueFrom: '',
                valueTo: '',
                shipmentNum: '',
                shipmentStatus: '',
                shipmentBL: '',
                shipmentLC: '',
                contractNum: '',
                contractStatus: '',
                contractType: ''
            };
            var predicate = 'modifiedOn';
            var order = 'desc';
            var sort = [predicate + ',' + order];
            var queryParams = {
                page: page,
                size: 10,
                sort: sort
            };
            queryParams = Object.assign({}, queryParams, vm.filterModelJapanInvoice);
            InvoiceGridDTO.query(queryParams, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.japanInvoices = [];
                vm.japanInvoicePagination.total = headers('X-Total-Count');
                vm.japanInvoicePagination.curPage = page;
                for(var i = 0; i < data.length; i++) {
                    vm.japanInvoices.push(data[i]);
                }
            }

            function onError(error) {
                if(error.status !== 401) {
                    ToastrService.error("Failed to get Japan Invoices", "Error!");
                }
            }
        }

        vm.createTab = function(data) {
            $scope.$emit('handleEmit', data);
        }

        $scope.$watch('vm.purchaseContractPagination.curPage', function() {
            getPurchaseContracts(vm.purchaseContractPagination.curPage);
        });

        $scope.$watch('vm.saleContractPagination.curPage', function() {
            getSaleContracts(vm.saleContractPagination.curPage);
        });

        $scope.$watch('vm.shipmentPagination.curPage', function() {
            getShipments(vm.shipmentPagination.curPage);
        });

        $scope.$watch('vm.purchaseInvoicePagination.curPage', function() {
            getPurchaseInvoices(vm.purchaseInvoicePagination.curPage);
        });

        $scope.$watch('vm.saleInvoicePagination.curPage', function() {
            getSaleInvoices(vm.saleInvoicePagination.curPage);
        });

        $scope.$watch('vm.japanInvoicePagination.curPage', function() {
            getJapanInvoices(vm.japanInvoicePagination.curPage);
        });

    }
})();
